import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'

//@ts-ignore
import LKButton from 'shared/LKButton'

const AddAndOpenAgainButton: FC<{
  FormName: string
  submitting: boolean
  onClick: () => void
  onClose?: () => void
}> = (props) => {
  const { FormName, submitting, onClick } = props
  const visible: boolean = useSelector((state) => formValueSelector(FormName)(state, 'action') === 'add')

  if (!visible) {
    return null
  }

  return (
    <LKButton alias="ok_add" onClick={onClick} style={{ width: 85 }} disabled={submitting} loading={submitting}>
      OK +
    </LKButton>
  )
}

export default AddAndOpenAgainButton
